<template>
  <v-container>

    <Titulo></Titulo>

    <NavBar v-if="loadMounted == true" :step="3" :typePlan="userData.typePlan"></NavBar>

    <br v-if="screen < 800">

    <v-stepper v-model="e1" elevation="0" style="margin-top: -80px;">
      <v-stepper-header>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Planes
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 12"
            step="5">Datos</v-stepper-step>
        </div>
      </v-stepper-header>

      <v-stepper-items>

        <v-stepper-content step="10">
          <v-form ref="form" v-model="valid">
            <v-container style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
              <div class="form-container">
                <v-col :class="vista">

                  <br>
                  <br>

                  <br v-if="screen > 800">
                  <br v-if="screen > 800">

                  <label>
                    <h3 class="text-center labelTitulo">
                      {{ capitalizeName(userData.name) }}, lamentablemente no podemos continuar con el proceso.
                  </h3>

                  <br>

                    <h3 class="text-center labelnoSubExcelente" >
                      <b>Debido a la condición de salud que declaraste, en este momento no podemos asegurarte. <br>
                      Si tienes dudas o deseas contactarte con nosotros, por favor haz clic aquí.</b>
                    </h3>

                 </label>

                  <br v-if="screen < 800">

                  <div class="button-container">

                    <v-btn
                      class="button-desing" style="background-color: #2D387C; color: white; border-radius: 12px; width: 300px;">
                      Llamar al 800 200 802
                    </v-btn>

                  </div>
                </v-col>
              </div>
            </v-container>
          </v-form>
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>

  </v-container>
</template>
  
<script>

import Titulo from "./Titulo.vue"
import NavBar from "@/components/NavBar.vue";
import CryptoJS from 'crypto-js';


export default {
  name: "Step4",
  components: { Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    loadMounted: false,
    userData: {
      name: null,
      typePlan: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
    },
    valid: false,
    stepperColor: '#4F74E3',
    screen: window.screen.width,
    stepId: null,
    components: { Titulo },
    e1: 10,
    questionRules: [(v) => !!v || "Debe seleccionar una opción"],
  }),
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    const userDataAux = sessionStorage.getItem('userData');

    if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
    //  console.log("userData: ", this.userData);
    } 

    this.userData.typePlan = sessionStorage.getItem('typePlan')
    this.userData.questionOne = sessionStorage.getItem('QOne')
    this.userData.questionTwo = sessionStorage.getItem('QTwo')
    this.userData.questionThree = sessionStorage.getItem('QThree')

    console.log(this.userData);
    if (this.screen > 800) {
      this.vista = 'vista2'
    } else {
      this.vista = 'vista'
    }
    this.loadMounted = true;
  },
  methods: {
    back() {
      this.$router.push({ path: '/og/dps' })
    },
    capitalizeName(name) {
            if (!name) return '';
            return name.charAt(0).toUpperCase() + name.slice(1);
    },
    validate() {
      sessionStorage.setItem('QOne', this.userData.name)
      sessionStorage.setItem('QOne', this.userData.questionOne)
      sessionStorage.setItem('QTwo', this.userData.questionTwo)
      sessionStorage.setItem('QThree', this.userData.questionThree)
      if (this.userData.typePlan == 'Individual') {
        this.$router.push({ path: '/og/datos-contratante' })
      } else {
        this.$router.push({ path: '/og/datos-beneficiarios' })
      }
    },
    volverAgregar() {
      if (this.userData.typePlan == 'Individual') {
        this.$router.push({ path: '/og/planes' })
      } else {
        this.$router.push({ path: '/og/beneficiarios' })
      }
    }
  }
};

</script>
  
<style lang="scss">
.labelNumLlamar {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 50px;
  // top: 175px;
  text-align: center;
}

.labelSuperior {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: justify;
  color: #232323;
  opacity: 0.75;
  height: 103px;
}

.labelTitulo {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #2D387C;
}

.labelQuestion1 {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #4040CF;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  justify-content: left;
}

.labelTexto {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  text-align: justify;
}

.labelTexto-negrita {
  font-family: Helvetica;
  font-style: italic;
  font-weight: bold;
  font-size: 11px;
  line-height: 16px;
  color: #232323;
  height: 138px;
  text-align: justify;
  hyphens: auto;
}

.labelBeneficioss {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 150px;
  text-align: justify;
}

.labelExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelSubExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
}

.labelNoExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelnoSubExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
  margin-bottom: -5%;
}

.vista {
  max-width: 1000px;
}

.vista2 {
  margin-top: -4%;
  min-width: 600px;
}

.step-data {
  max-width: 85%;
  align-items: center;
  // display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 800px;
}

.form-box {
  box-sizing: border-box;
  max-width: 800px;
  background: #F3F3F3;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  border-radius: 6px;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

h1 {
  font-weight: 500;
  text-align: center;
  color: #464e71;
  margin-bottom: 2rem;
}

h2 {
  font-weight: 500;
  color: #464e71;
  margin-bottom: 1rem;
}

p {
  text-align: center;
}

.back-container {
  width: 100%;
  align-items: flex-start;

  .back-button {


    &:hover {
      opacity: 1;
    }
  }
}

.button-container {
  text-align: center;
}

.forecast-selector {
  text-transform: uppercase;
  font-weight: 600;
  color: #464e71;
}

.v-btn__content {
  padding: 0.75rem;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: center;
  margin: auto;
}

</style>